module.exports = __webpack_public_path__ + "bf2532df/img/archive-icon.0a6a9de3.svg";